import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import NumberPhone from "./logInPages/NumberPhone";
import LogInCode from "./logInPages/LogInCode";
import Profile from "./logInPages/Profile";
import LoginPasswordPage from "./logInPages/LoginPasswordPage";

const LogIn = () => {
    return (
        <div id="log-in">
            <div id="toggle-log-in"
                 className="log-in-toggle position-absolute xp-4 animate__fadeOut_login">
                <div className="close-log-in position-absolute" id="close-log-in">
                    <IconName name="expand_close" className="icon"/>
                </div>
                <div className="log-in-wrapper">
                    <NumberPhone/>
                    <LogInCode/>
                    <Profile/>
                    <LoginPasswordPage/>
                </div>
            </div>
        </div>
    );
};

export default LogIn;
